/**
 * @module use-cases/version/slice
 * @desc Version Slice (Reducers and ExtraReducers)
 *
 */

import { createSlice } from 'core/use-cases/utilities';

import { initialState } from './initial-state';

const versionSlice = createSlice({
  name: 'version',
  initialState,
  reducers: {},
});

export const { reducer } = versionSlice;
